import type { KeyboardEvent, KeyboardEventHandler } from "react";

// Lets a clickable non-button element react to Enter/Space like a native button.
export const onActivationKey =
  <E extends Element>(handler: () => void): KeyboardEventHandler<E> =>
  (e: KeyboardEvent<E>): void => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handler();
    }
  };
